/* eslint-disable import/no-unresolved */
/* eslint-disable react/no-array-index-key */
import {
    AccordionItem, AccordionItemBody, AccordionItemHeader, Accordions,
} from 'appkit-react';
import { Col, Form, Row } from 'react-bootstrap';

const FRY7QResultsAccordian = (
    {
        failedTestResults, criteria,
    },
) => (
    <div>
        <Accordions className="true-comply-fry7q-accordion" activeItem={['panel-1']}>
            <AccordionItem itemId="panel-1" size="lg">
                <AccordionItemHeader className="background-white header" title="DIAGNOSTIC CRITERIA" />
                <AccordionItemBody className="background-white" size="lg">
                    <hr style={{ marginTop: 0 }} />
                    <Row>
                        <Col md={6}>
                            <Row>
                                <Col md={3} className="a-h6">
                                    Category
                                    <span className="label">: </span>
                                </Col>
                                <Col md={8}>
                                    {criteria && criteria.editType}
                                </Col>
                            </Row>
                            <Row className="row-margin">
                                <Col md={3} className="a-h6">
                                    MDRM Number
                                    <span className="label">: </span>
                                </Col>
                                <Col md={8}>
                                    {criteria.mdrmNumber}
                                </Col>
                            </Row>
                            <Row className="row-margin">
                                <Col md={3} className="a-h6">
                                    Description
                                    <span className="label">: </span>
                                </Col>
                                <Col md={8}>
                                    {criteria.editTest}
                                </Col>
                            </Row>
                        </Col>
                        <Col md={6}>
                            <Row className="row-margin">
                                <Col md={3} className="a-h6">
                                    Effective End Date
                                    <span className="label">: </span>
                                </Col>
                                <Col md={8}>
                                    {criteria.effectiveEndDate}
                                </Col>
                            </Row>
                            <Row className="row-margin">
                                <Col md={3} className="a-h6">
                                    Edit Number
                                    <span className="label">: </span>
                                </Col>
                                <Col md={8}>
                                    {criteria.editNumber}
                                </Col>
                            </Row>
                            <Row className="row-margin" style={{ paddingBottom: '1.5rem' }}>
                                <Col md={3} className="a-h6">
                                    Schedule / Part
                                    <span className="label">: </span>
                                </Col>
                                <Col md={8}>
                                    {`${criteria.schedule} / ${criteria.targetItem}`}
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </AccordionItemBody>
            </AccordionItem>
            <AccordionItem itemId="panel-2" style={{ marginTop: '1rem' }}>
                <AccordionItemHeader className="background-white header" title="RESULTS" />
                <AccordionItemBody className="background-white">
                    <hr style={{ marginTop: 0 }} />
                    {
                        (failedTestResults && failedTestResults.length > 0)
                        && failedTestResults.map(result => {
                            const {
                                testFail, testDate, remediationCount, errorData, errorMessage,
                            } = result;
                            return (
                                <div key={testDate}>
                                    <Row>
                                        <Col md={6}>
                                            {errorMessage.length > 0 && (
                                                <Row>
                                                    <Col md={4} className="a-h6">
                                                        Run Date
                                                        <span className="label">: </span>
                                                    </Col>
                                                    <Col md={8}>
                                                        {testDate}
                                                    </Col>
                                                </Row>
                                            )}
                                            {errorMessage.length > 0 && (
                                                <Row className="row-margin">
                                                    <Col md={4} className="a-h6">
                                                        Remediation Count
                                                        <span className="label">: </span>
                                                    </Col>
                                                    <Col md={8}>
                                                        {remediationCount}
                                                    </Col>
                                                </Row>
                                            )}
                                        </Col>
                                        <Col md={6}>
                                            <Row className="row-margin">
                                                <Col md={3} className="a-h6">
                                                    Overall results
                                                    <span className="label">: </span>
                                                </Col>
                                                <Col md={8}>
                                                    <div>
                                                        {`${testFail ? '100% Failure' : '0% Failure'}`}
                                                    </div>
                                                    <div>
                                                        {`${testFail ? '1 of 1 records failed' : '0 of 1 records failed'}`}
                                                    </div>
                                                    `
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <hr style={{ marginTop: 0 }} />
                                    {(failedTestResults && errorMessage) && (
                                        <span className="a-h5" style={{ marginLeft: '0.5rem' }}>REPORT</span>
                                    )}
                                    <Row style={{ marginLeft: '0.5rem', marginRight: '0.5rem', backgroundColor: '#e0e0e0' }}>
                                        <Col sm="8" md="8"><Form.Label className="a-h6">Error Message</Form.Label></Col>
                                        <Col sm="2" md="2"><Form.Label className="a-h6">Entered Value</Form.Label></Col>
                                        <Col sm="2" md="2"><Form.Label className="a-h6">Checked Value</Form.Label></Col>
                                    </Row>
                                    {/* )} */}
                                    {
                                        errorData
                                            ? errorData.map((errorDataArray, index) => {
                                                const message = errorMessage[index];
                                                return (
                                                    <Row
                                                        key={index}
                                                        style={{
                                                            marginLeft: '0.5rem',
                                                            marginRight: '0.5rem',
                                                            backgroundColor: '#f5f5f5',
                                                        }}
                                                    >
                                                        <Col
                                                            sm="8"
                                                            md="8"
                                                        >
                                                            <p
                                                                className="true-comply-result__accordion-subtxt"
                                                            >
                                                                {message}
                                                            </p>
                                                        </Col>
                                                        <Col
                                                            sm="2"
                                                            md="2"
                                                        >
                                                            <p
                                                                className="true-comply-result__accordion-subtxt"
                                                            >
                                                                {(errorDataArray.split(',')[0])}
                                                            </p>
                                                        </Col>
                                                        <Col
                                                            sm="2"
                                                            md="2"
                                                        >
                                                            <p
                                                                className="true-comply-result__accordion-subtxt"
                                                            >
                                                                {(errorDataArray.split(',')[1])}
                                                            </p>
                                                        </Col>
                                                    </Row>
                                                );
                                            })
                                            : (
                                                <Row>
                                                    <Col><div className="true-comply-result__no-failed-result">No Failed Results...!! </div></Col>
                                                </Row>
                                            )
                                    }
                                </div>
                            );
                        })
                    }
                </AccordionItemBody>
            </AccordionItem>
        </Accordions>
    </div>
);

export default FRY7QResultsAccordian;
